import { render, staticRenderFns } from "./Root.vue?vue&type=template&id=9cdfb4ee"
import script from "./Root.vue?vue&type=script&lang=js"
export * from "./Root.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/tailwind.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Root.vue?vue&type=style&index=1&id=9cdfb4ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports